"use client"

import dynamicImport from "next/dynamic"
import { Suspense } from "react"
import { useParams } from "next/navigation"

const SingleGameContent = dynamicImport(() => import("./SingleGameContent"), {
  ssr: false,
})

export const dynamic = "force-dynamic"

export default function OvertimeEventPage() {
  const params = useParams()
  const marketAddress = params!.gameId as string

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <SingleGameContent marketAddress={marketAddress} />
    </Suspense>
  )
}
